/**
 * SlackAccount model - Slack workspace account extending the Account STI base
 */

import { smrt } from '@happyvertical/smrt-core';
import type { MessageSenderInterface, SlackAccountOptions } from '../types';
import { Account } from './Account';

@smrt({
  tableStrategy: 'sti',
  api: { include: ['list', 'get'] },
  mcp: { include: ['list', 'get'] },
  cli: { include: ['list', 'get'] },
})
export class SlackAccount extends Account {
  workspaceId = '';
  workspaceName = '';
  botUserId = '';

  constructor(options: SlackAccountOptions = {}) {
    super(options);

    if (options.workspaceId !== undefined)
      this.workspaceId = options.workspaceId;
    if (options.workspaceName !== undefined)
      this.workspaceName = options.workspaceName;
    if (options.botUserId !== undefined) this.botUserId = options.botUserId;

    // Default provider type
    if (!this.providerType) this.providerType = 'slack';
    this.channelType = 'slack';
  }

  /**
   * Create a sender for this Slack account
   */
  override async createSender(): Promise<MessageSenderInterface> {
    const { SlackSender } = await import('../senders/SlackSender');
    return new SlackSender(this);
  }
}
